import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Button, Modal } from '@storable/canaveral-components';
import { LimitContextProvider } from '../../../../../../admin/contexts/LimitContext';
import MediaGallerySelector from '../../../../../../admin/containers/MediaGallerySelector';

const propTypes = {
  existingMedium: PropTypes.string,
  hideGallery: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
};

const defaultProps = {
  existingMedium: undefined,
};

const MediaGallerySelectModal = ({
  existingMedium,
  hideGallery,
  onSelect,
}) => {
  const [selectedMedium, setSelectedMedium] = useState();
  const [usedMedia, setUsedMedia] = useState();

  useEffect(() => {
    if (existingMedium) {
      setUsedMedia([existingMedium]);
    }
  });
  const onClickChooseImage = () => {
    onSelect(selectedMedium);
    setUsedMedia(selectedMedium);
    setSelectedMedium(null);
    hideGallery();
  };

  return (
    <Modal onDismiss={hideGallery} show size="xl">
      <Modal.Header>
        <Modal.Title id="image-editor-modal">
          Media Gallery
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <LimitContextProvider>
          <MediaGallerySelector
            setSelectedMedium={setSelectedMedium}
            selectedMedium={selectedMedium}
            usedMedia={usedMedia}
            showTrash={false}
            showSearch
          />
        </LimitContextProvider>
      </Modal.Body>
      <Modal.Footer>
        <Button
          onClick={hideGallery}
          context="neutral"
        >
          Cancel
        </Button>
        <Button
          context="positive"
          disabled={!selectedMedium}
          onClick={onClickChooseImage}
        >
          Choose Image
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

MediaGallerySelectModal.propTypes = propTypes;
MediaGallerySelectModal.defaultProps = defaultProps;

export default MediaGallerySelectModal;
